// UserPopup.vue

<template>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      	<v-card>
	        <v-card-title>
	        	<span class="headline">User</span>
			    <v-spacer />
	        	<v-text-field hide-details disabled reverse label="ID" v-model="item.id"></v-text-field>
	        </v-card-title>
	        <v-card-text>
	        	<v-form>
	        		<v-row>
	        			<v-col cols="12" sm="6">
	        				<v-text-field hide-details label="Name" v-model="item.name"></v-text-field>
			        	</v-col>
	        			<v-col cols="12" sm="6">
	        				<v-text-field hide-details label="Email" v-model="item.email"></v-text-field>
			        	</v-col>
					</v-row>
	        		<v-row>
	        			<v-col cols="12" sm="6">
	        				<v-text-field hide-details label="Passwort" type="password"
							 v-model="item.password" autocomplete="new-password"
	        				 id="password" name="password"></v-text-field>
			        	</v-col>
	        			<v-col cols="12" sm="6">
	        				<v-text-field hide-details label="Passwort Bestätigung" type="password"
							 v-model="item.password_confirmation" autocomplete="new-password"
							 id="password-confirm" name="password_confirmation"></v-text-field>
			        	</v-col>
					</v-row>
	        		<v-row>
			    		<v-spacer />
	        			<v-col cols="12" sm="6">
							<v-select hide-details label="Team creating" :items="teams"
							 v-model="item.team_id" item-text="name" item-value="id"></v-select>
			        	</v-col>
					</v-row>
	        	</v-form>
	        </v-card-text>
	        <v-card-text>
				<span>Roles</span>
				<v-chip-group v-model="roleSelection" multiple column :mandatory="false" active-class="indigo">
					<v-chip v-for="role in roles" :key="role.id" :value="role.id" @click="onToggleRole()">
						<v-avatar v-if="isActiveRole(role.id)"><v-icon>check_circle_outline</v-icon></v-avatar>
            			{{ role.name }}
            		</v-chip>
				</v-chip-group>
				<span>Teams</span>
				<v-chip-group v-model="teamSelection" multiple column :mandatory="false" active-class="indigo">
					<v-chip v-for="team in teams" :key="team.id" :value="team.id" @click="onToggleTeam()">
						<v-avatar v-if="isActiveTeam(team.id)"><v-icon>check_circle_outline</v-icon></v-avatar>
            			{{ team.name }}
            		</v-chip>
				</v-chip-group>
        	</v-card-text>
    		<v-divider></v-divider>
        	<v-card-actions>
        		<v-btn text class="warning mx-1 mt-3" @click="onCancel()">Abbrechen</v-btn>
        		<v-btn v-if="!error" text class="success mx-0 mt-3" :loading="loading" :disabled="loading" @click="onSubmit()">Speichern</v-btn>
        		<v-btn v-else text class="error mx-0 mt-3" disabled>{{ error }}</v-btn>
			    <v-spacer />
        		<v-btn text class="primary mx-1 mt-3" @click="onTest()">Test0</v-btn>
        		<v-btn text class="primary mx-1 mt-3" @click="onSaveDoc()">Test1</v-btn>
        		<v-btn text class="primary mx-1 mt-3" @click="onPrintDoc()">Test2</v-btn>
        	</v-card-actions>
      	</v-card>
		<v-dialog v-model="showmessage">
			<v-toolbar dark color="warning" dense>
				<v-toolbar-title class="white--text">Notification</v-toolbar-title>
			</v-toolbar>
			<v-card tile>
				<v-card-text color="red" v-html="message"/>
				<v-card-actions>
					<v-spacer/>
					<v-btn color="blue" text @click="onMessageClose()">Ok</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
        <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay>
    </v-dialog>          
</template>

<script>
	import { mapGetters } from 'vuex'
	export default {
	  	name: 'UserPopup',
		components: {
		},
	  	props: {
	  		model: {
	  			type: Object,
	  			default () {
	  				return {}
	  			}
	  		},
	  	},
		data() {
			return {
				roleSelection: [],
				teamSelection: [],
				dialog: false,
				loading: false,
				error: '',
				message: '',
				showmessage: false,
				editorContent: '<h1>Editor contents</h1>',
				editorSaving: false,
			}
		},
		computed: {
			...mapGetters({
				item: 'users/getUser',
				roles: 'users/getRoles',
				teams: 'users/getTeams',
			}),
			/*filteredTeams: function () {
				return this.teams.map(x => x.name)
			}*/
		},
		methods: {
			closeDialog(event) {
    			this.loading = false
				this.dialog = false
      			this.$store.commit('users/resetUser')
	      		this.$emit(event)
			},
			msgError(errortext) {
    			this.loading = false
    			this.error = "Eingaben konnten nicht gespeichert werden"
		        setTimeout(() => {
		        	this.error = ''
		        }, 5000);
		        this.message = '<code>' + JSON.stringify(errortext).substring(0, 200) + '</code>'
		        this.showmessage = true
			},
			onSubmit() {
	        	this.loading = true	
		        const data = this.item
		        data.roles = this.roleSelection
		        data.teams = this.teamSelection
				let self = this
	      		this.$store.dispatch('users/storeUser', data)
	      		.then((response) => {
	      			self.closeDialog('popup-submitted')
      			})
		    	.catch((error) => {
		    		console.log('users->submit->error')
			    	console.log(error)
			    	self.msgError(error.response.data)
			    });
			},
			onCancel() {
	      		this.closeDialog('popup-cancelled')
			},
			onMessageClose() {
		        this.message = ''
		        this.showmessage = false			
			},
			fetchData(id) {
				this.loading = true
				let self = this
				this.$store.dispatch('users/editUser', id)
				.then((response) => {
					self.fetchRoles()
					self.fetchTeams()
				})
				.catch((error) => {
					console.log("fetchData->error")
					console.log(error)
					self.msgError(error.response.data)
					self.loading = false
				});
			},
			fetchRoles() {
				this.loading = true
				let self = this
				this.$store.dispatch('users/getRoles')
				.then((response) => {
					self.loading = false
				})
				.catch((error) => {
					console.log(error)
					self.loading = false
				});
			},
			fetchTeams() {
				this.loading = true
				let self = this
				this.$store.dispatch('users/getTeams')
				.then((response) => {
					self.loading = false
				})
				.catch((error) => {
					console.log(error)
					self.loading = false
				});
			},
			isActiveRole(id) {
				return this.roleSelection.includes(id)
			},
			isActiveTeam(id) {
				return this.teamSelection.includes(id)
			},
			onPrintDoc() {
				console.log('print doc')
				let id = 4
				let path = "/pdf/doc/" + id
				window.open(document.location.origin + path, "_blank")
			},
			onToggleRole() {

			},
			onToggleTeam() {

			},
		},
		mounted() {
		},
	  	watch: {
	  		item () {
	  			this.roleSelection = []
	  			let userRoles = this.item.roles
	  			if(Array.isArray(userRoles)) {
	  				for(var role of userRoles) this.roleSelection.push(role.id)
	  			}
	  			this.teamSelection = []
	  			let userTeams = this.item.teams
	  			if(Array.isArray(userTeams)) {
	  				for(var team of userTeams) this.teamSelection.push(team.id)
	  			}
	  		},
		    model (newValue) {
			    if(newValue && typeof newValue === 'object' && Object.keys(newValue).length !== 0) {
			    	this.fetchData(this.model.id)
			    } else if(newValue && typeof newValue === 'object' && Object.keys(newValue).length === 0) {
			    	this.fetchRoles()
			    	this.fetchTeams()
			    }
		    	this.editorSaving = true
				this.dialog = true
		    },
	  	},
	}  
</script>

<style scoped>
</style>